var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "470.000000pt",
    height: "470.000000pt",
    viewBox: "0 0 470.000000 470.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,470.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3815 4694 c-299 -49 -536 -251 -632 -539 -22 -69 -26 -98 -27 -210 -1 -71 1 -149 4 -173 l5 -43 -894 -439 -894 -440 -59 55 c-109 101 -233 170 -365 201 -110 27 -277 22 -388 -11 -219 -64 -382 -200 -480 -400 -64 -129 -80 -196 -80 -345 0 -149 16 -216 80 -345 132 -268 389 -427 690 -427 139 -1 219 18 353 84 l102 50 913 -376 c501 -206 935 -384 962 -396 l50 -21 -3 -112 c-4 -125 11 -217 51 -317 93 -228 286 -399 528 -466 47 -13 100 -18 199 -18 126 0 141 2 230 33 126 43 218 99 305 185 89 89 141 167 182 277 191 509 -179 1048 -720 1049 -229 0 -446 -100 -598 -277 -23 -26 -46 -50 -51 -51 -4 -2 -189 71 -411 162 -1099 451 -1400 576 -1404 580 -3 3 9 39 26 80 59 143 78 327 47 461 -8 33 -13 61 -12 62 1 1 135 67 297 147 162 79 483 237 714 350 231 114 500 246 598 293 l178 87 45 -47 c101 -105 212 -174 354 -219 65 -20 95 -23 220 -22 130 0 153 3 225 27 259 87 449 286 521 548 13 47 18 100 18 199 0 126 -2 141 -33 230 -43 128 -100 220 -190 311 -91 91 -184 147 -310 189 -78 26 -113 32 -205 35 -61 2 -124 1 -141 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.80386d82d36b9db6c7b179352c5af4d6.svg";
export { ForwardRef as ReactComponent };